import React from "react";
import PolicyPage, { ContactEmail } from "./PolicyPage";

function IntellectualProperty() {
  return (
    <PolicyPage title="Intellectual Property Policy">
      <h2>Our content</h2>
      <p>The camartzuno name, original photographs, illustrations, product text, graphics, layout, and software are owned by or lawfully licensed to camartzuno and are protected by applicable laws. Third-party names and marks belong to their respective owners.</p>

      <h2>Permitted use</h2>
      <p>You may view the site and save or print a reasonable portion for personal, non-commercial shopping and record-keeping. This limited permission does not transfer ownership and may be revoked if misused.</p>

      <h2>Uses requiring permission</h2>
      <p>Without prior written permission, do not reproduce, republish, sell, license, modify, remove rights notices from, frame, mirror, systematically extract, or use site content to train or populate a commercial product, catalogue, dataset, or competing store, except where applicable law expressly permits.</p>

      <h2>No implied endorsement</h2>
      <p>You may link to a public page in a fair and lawful way that does not imply sponsorship or damage our reputation. Do not use our branding in a domain, advertisement, counterfeit listing, or misleading account.</p>

      <h2>Reporting suspected infringement</h2>
      <p>If you believe content on this site infringes your rights, email <ContactEmail /> with your name and contact details, identification of the protected work, the exact page and material at issue, the basis for your claim, a good-faith statement, and confirmation that the information is accurate and you are authorized to act. A typed signature is acceptable.</p>

      <h2>Review and response</h2>
      <p>We may request supporting information, restrict material while reviewing it, notify the person who supplied it, or take other reasonable action. Knowingly false claims may create liability. This process does not provide legal advice or replace any formal notice procedure required by applicable law.</p>
    </PolicyPage>
  );
}

export default IntellectualProperty;
